import queryString from 'query-string';


import {stomp} from './stomp';
import { stealth } from './stealth';
import { tvWidget } from '..';

var stealth_url = 'wss://feed.stealthtrader.com:443'; //"wss://test.stealthtrader.com:443";
var chartValuesHistory = [];
var isCapturedOnce = false;
var history = {};
var lastStealthUpdate = {
  lastDirection: null,
  lastTime: null,
};
const _subs = [];
const unixTimeOffset = 5364662400; //because we use time from 1800 and unix time is 1970+
//const supportedResolutions = ["1", "3", "5", "15", "30", "60", "120", "240", "D", "W"]
const supportedResolutions = ['1', '60'];

const config = {
  supported_resolutions: supportedResolutions,
  supports_marks: true,
};


const qParams = queryString.parse(window.location.search);
var socketStealth = null;
var currentSubscriptionId = null;
var currentStrategySubscriptionId = null;
/* QUERY PARAMS START*/
var instrumentType = qParams.instrumentType ? qParams.instrumentType : 'CS';
var brokerAccountId = qParams.brokerAccountId
  ? qParams.brokerAccountId
  : '6a4d2ba9-ebae-405b-830e-1cbac7eb9f89';
var bearerToken = qParams.bearerToken ? qParams.bearerToken : loginStealth();
var strategyVersion = qParams.strategy ? qParams.strategy : 'Crb7.6';
var syncType = qParams.syncType ? qParams.syncType : 'delay';
var symbolFromParams = qParams.symbol ? qParams.symbol : 'AAPL';
var significantDigits = qParams.sigDig ? qParams.sigDig : '';
/* QUERY PARAMS END */
//const unsubEvent = new Event('unsubscribe');
const subEvent = new Event('subscribe');
//const getHistoryEvent = new Event('history');

export async function loginStealth() {
  
  const baseUrl =
    'https://mercury.pilottrading.co/auth/credentials?UserName=qgsi_testing@quantgatesystems.com&Password=12345678!A';

  let result = await fetch(baseUrl)
    .then(response => response.json())
    .then(data => data.BearerToken);

  bearerToken = result;

  return result;
}

export default {
  history: history,
  lastStealthUpdate: lastStealthUpdate,
  currentSubscriptionId: currentSubscriptionId,
  currentStrategySubscriptionId: currentStrategySubscriptionId,
  onReady: cb => {
    
    setTimeout(() => cb(config), 0);
  },
  searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
    for (var i = 0; i < data.length; ++i) {
      if (!data[i].params) {
        data[i].params = [];
      }
    }
    if (typeof data.s === 'undefined' || data.s !== 'error') {
      onResultReadyCallback(data);
    } else {
      onResultReadyCallback([]);
    }
    
  },
  resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
    // expects a symbolInfo object in response
    

    //let symbolParsed = parseFullSymbol(symbolName);

    let exchange;
    let splitSymbol;
    let split_data = symbolName.split(':');
    

    if (split_data[0].match(/^(\w+)\/(\w+)$/)) {
      splitSymbol = split_data[0].split('/');
      symbolName = splitSymbol[0];
      exchange = split_data[1];
      
    } else {
      symbolName = split_data[0];
      exchange = split_data[1];
    }

    var symbol_stub = {
      name: symbolName,
      description: '',
      type: '',
      session: '24x7',
      timezone: 'America/Toronto', //'Etc/UTC',
      ticker: symbolName,
      exchange: exchange,
      minmov: 1,
      pricescale: significantDigitsForPriceScale(significantDigits), //instrumentType === 'CRY' ? 100000000 : instrumentType === 'FX' ? 100000 : 100,
      has_intraday: true,
      intraday_multipliers: ['1', '60'],
      supported_resolution: supportedResolutions,
      volume_precision: 8,
      data_status: 'streaming',
    };

    /* if (split_data[1].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY/) || split_data[0].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY/)) {
      symbol_stub.pricescale = 100;
      //console.log(symbol_stub);
    } */

    setTimeout(function () {
      onSymbolResolvedCallback(symbol_stub);
    }, 0);
    // onResolveErrorCallback('Not feeling it today')
  },
  getBars: function (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback,
  ) {
    
    const { from, to, firstDataRequest} = periodParams;
    // console.log('function args',arguments)
    // console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)

    //recieve first message and populate chartHistory

    //console.log('symbol info in get bars',symbolInfo, resolution, firstDataRequest);

    if (!firstDataRequest) {
      
      onHistoryCallback([], {noData: true});
    } else {
      connectToStealth(symbolInfo.name, resolution, 'fromGetBars')
        .then(chartValues => {
          var bars = chartValues.map(el => {
            //console.log('each element', el.value);
            return {
              time: el.value[0] * 1000,
              open: el.value[1],
              high: el.value[2],
              low: el.value[3],
              close: el.value[4],
              volume: el.value[5],
            };
          });

          bars.sort((a, b) => {
            let date1 = new Date(a.time);
            let date2 = new Date(b.time);
            //a.time - b.time
            return date1 - date2;
          }); //tradingview requires ascending order of time

          if (firstDataRequest) {
            var lastBaring = bars[bars.length - 1];
            history[symbolInfo.name] = {lastBar: lastBaring};
          } else {
            console.log('history if not same request', history);
          }

          if (bars.length) {
            onHistoryCallback(bars, {noData: false});
          } else {
            onHistoryCallback(bars, {noData: true});
          }
        })
        .catch(err => {
          console.log('error getBars', {err});
          onErrorCallback(err);
        });
    }
  },
  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscribeUID,
    onResetCacheNeededCallback,
  ) => {
    
    //stream.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback)

    //console.log('in subscribe bars function', currentSubscriptionId);

    var newSub = {
      currentSubscriptionId,
      currentStrategySubscriptionId,
      resolution,
      symbolInfo,
      lastBar: history[symbolInfo.name].lastBar,
      listener: onRealtimeCallback,
    };

    _subs.push(newSub);
  },
  unsubscribeBars: subscriptionId => {
    

    //stream.unsubscribeBars(subscriberUID)
    _subs.pop();
    socketStealth.close();
    socketStealth = null;
    isCapturedOnce = false;
  },
  calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
    //optional
    // console.log('=====calculateHistoryDepth running')
    // while optional, this makes sure we request 24 hours of minute data at a time
    // CryptoCompare's minute data endpoint will throw an error if we request data beyond 7 days in the past, and return no data
    //return resolution < 60 ? {resolutionBack: 'D', intervalBack: '1'} : undefined
    return {resolutionBack: 'D', intervalBack: '1'};
  },
  getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
    //optional
    /* var Arr = [   
      {
        id: 1,
        time: endDate,
        color: 'blue',
        text: 'Buy',
        label: 'B',
        labelFontColor: 'yellow',
        minSize: 30        
      },
      {
        id: 2,
        time: startDate,
        color: 'red',
        text: 'Sell',
        label: 'S',
        labelFontColor: 'yellow',
        minSize: 30        
      },     
    ]; */
    //onDataCallback(Arr);
    
  },
  getTimeScaleMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
    //optional
    console.log('=====getTimeScaleMarks running');
  },
  getServerTime: cb => {
    // console.log('=====getServerTime running')
  },
};

function connectToStealth(symbolName, resolution, type) {
  
  return new Promise((resolve, reject) => {
    if (!socketStealth) {
      
      socketStealth = new WebSocket(stealth_url);
      socketStealth.binaryType = 'arraybuffer';
    } else {
      
      //resolve(chartValuesHistory);
      _subs.pop();
      socketStealth.close();
      socketStealth = null;
      isCapturedOnce = false;
      chartValuesHistory = [];
      history = {};
      socketStealth = new WebSocket(stealth_url);
      socketStealth.binaryType = 'arraybuffer';
      //socketStealth.dispatchEvent(unsubEvent);
      //socketStealth.dispatchEvent(subEvent);
    }
    socketStealth.addEventListener('open', event => {
      const setting = stealth.ConnectSettings.create({
        productType: 'P',
      });

      const body = stealth.ConnectSettings.encode(setting).finish();

      const frameProps = {
        connect: stomp.ConnectRequest.create({
          acceptVersion: '1.0',
          login: brokerAccountId,
          passcode: bearerToken,
          body: body,
        }),
      };
      sendRequestFrame(frameProps, socketStealth);
    });

    socketStealth.addEventListener('message', event => {
      
      const responseFrame = stomp.ResponseFrame.decode(new Uint8Array(event.data));

      if (responseFrame.response === 'connected') {
        let heartbeatFrame = {heartbeat: {}};
        sendHeartBeat(heartbeatFrame, socketStealth);
      }

      if (responseFrame.singleMessage) {
        handleMessage([responseFrame.singleMessage]);
      }

      if (responseFrame.batchMessages && responseFrame.batchMessages.message) {
        handleMessage(responseFrame.batchMessages.message);
      }

      if (responseFrame.response === 'heartbeat') {
        //subscribeSymbolToMarketData();
        socketStealth.dispatchEvent(subEvent);
      }
    });

    socketStealth.addEventListener('subscribe', event => {
      subscribe();
    });

    socketStealth.addEventListener('unsubscribe', event => {
      sendRequestFrame(
        {
          unsubscribe: {
            subscriptionId: currentSubscriptionId,
          },
        },
        socketStealth,
      );
      sendRequestFrame(
        {
          unsubscribe: {
            subscriptionId: currentStrategySubscriptionId,
          },
        },
        socketStealth,
      );
    });

    function handleMessage(batch) {
      batch.forEach(item => {
        //console.log('item sub id',  item.subscriptionId, Number(currentSubscriptionId));
        if (item.subscriptionId === Number(currentSubscriptionId)) {
          let dataFromMessage = stealth.ChartUpdate.decode(item.body);
          if (dataFromMessage.values.length > 1 && !isCapturedOnce) {
            dataFromMessage.values.sort((a, b) => a.time - b.time);
            chartValuesHistory = dataFromMessage.values;
            isCapturedOnce = true;
            if (type === 'fromGetBars') {
              resolve(chartValuesHistory);
            }
          }
          if (type === 'fromSubscribe') {
            resolve(dataFromMessage);
          }

          let latestData = dataFromMessage.values[0];
          let newData = {
            time: latestData.value[0] * 1000,
            open: latestData.value[1],
            high: latestData.value[2],
            low: latestData.value[3],
            close: latestData.value[4],
            volume: latestData.value[5],
          };

          if (_subs.length >= 1) {
            
            if (
              typeof _subs[0].lastBar === 'undefined' &&
              newData.time < _subs[0].lastBar.time / 1000
            ) {
              return;
            }
            
            /**@description ignore 0 values and don't draw them */
            if(newData.close === 0 || newData.high === 0 || newData.low === 0 || newData.open === 0)
            {
              return;
            }
            let _lastBar = updateBar(newData, _subs[0]);

            _subs[0].listener(_lastBar);
            
            _subs[0].lastBar = _lastBar;
          }
        } else {
          try {
            
            let dataFromMessage = stealth.StrategyUpdate.decode(item.body);
            let stratData = dataFromMessage.signal;

            /* let temp = dataFromMessage.entryProgress;
            console.log(
              temp,
              ((dataFromMessage.timestamp - lastStealthUpdate.lastTime) * 100) / 60 / 60,
              lastStealthUpdate.lastDirection,
            ); */
            
            if (stratData) {
              if (
                stratData === 1 &&
                (dataFromMessage.timestamp - lastStealthUpdate.lastTime) / 60 >= 15 //=== 1 long
              ) {
                lastStealthUpdate = {
                  lastDirection: stratData,
                  lastTime: dataFromMessage.timestamp,
                };
                console.log('buy');
                let entId = tvWidget.activeChart().createShape(
                  {time: dataFromMessage.timestamp - unixTimeOffset, channel: 'low'},
                  {
                    shape: 'icon',
                    icon: 0xf0d8,
                    zOrder: 'top',
                    overrides: {
                      size: 60,
                      text: 'positive',
                      color: 'cyan',
                    },
                    lock: true,
                    disableSelection: true,
                  },
                );
                console.log('after draw buy');
              } else if (
                stratData === 2 &&
                (dataFromMessage.timestamp - lastStealthUpdate.lastTime) / 60 >= 15 //=== 2
              ) {
                lastStealthUpdate = {
                  lastDirection: stratData,
                  lastTime: dataFromMessage.timestamp,
                };
                console.log('sell');
                let entIdd = tvWidget.activeChart().createShape(
                  {time: dataFromMessage.timestamp - unixTimeOffset, channel: 'high'},
                  {
                    shape: 'icon',
                    icon: 0xf0d7,
                    overrides: {
                      size: 60,
                      text: 'negative',
                      color: 'red',
                    },
                    zOrder: 'top',
                    lock: true,
                    disableSelection: true,
                  },
                );
                console.log('after draw sell');
              } else if (stratData === 2 && lastStealthUpdate.lastDirection === 1) {
                lastStealthUpdate = {
                  lastDirection: stratData,
                  lastTime: dataFromMessage.timestamp,
                };
                
                let entIdd = tvWidget.activeChart().createShape(
                  {time: dataFromMessage.timestamp - unixTimeOffset, channel: 'high'},
                  {
                    shape: 'icon',
                    icon: 0xf0d7,
                    overrides: {
                      size: 60,
                      text: 'negative',
                      color: 'red',
                    },
                    zOrder: 'top',
                    lock: true,
                    disableSelection: true,
                  },
                );
                
              } else if (stratData === 1 && lastStealthUpdate.lastDirection === 2) {
                lastStealthUpdate = {
                  lastDirection: stratData,
                  lastTime: dataFromMessage.timestamp,
                };
                
                let entId = tvWidget.activeChart().createShape(
                  {time: dataFromMessage.timestamp - unixTimeOffset, channel: 'low'},
                  {
                    shape: 'icon',
                    icon: 0xf0d8,
                    zOrder: 'top',
                    overrides: {
                      size: 60,
                      text: 'positive',
                      color: 'cyan',
                    },
                    lock: true,
                    disableSelection: true,
                  },
                );
                
              }
            }
          } catch (e) {
            console.log('Error in drawing indicator', e);
          }
        }
      });
    }

    function sendRequestFrame(frameProperties, socket) {
      try {
        const msg = stomp.RequestFrame.encode(frameProperties).finish();
        
        socket.send(msg);
      } catch (err) {
        console.log(err);
      }
    }
    function sendHeartBeat(frameProperties, socket) {
      //loop this
      sendRequestFrame(frameProperties, socket);
      
    }

    function subscribe() {
      if (instrumentType === 'CRY') {
        currentSubscriptionId = createSubscription(
          `/chart/bar/${syncType}/${symbolFromParams}/${resolution}m`,
          1000,
        );
        currentStrategySubscriptionId = createSubscription(
          `/strategy/${strategyVersion}/${syncType}/${symbolFromParams}`,
          1000,
        );
      } else {
        
        currentSubscriptionId = createSubscription(
          `/chart/bar/${syncType}/${symbolName}/${resolution}m`,
          1000,
        );
        currentStrategySubscriptionId = createSubscription(
          `/strategy/${strategyVersion}/${syncType}/${symbolName}`,
          1000,
        );

      }
    }

    function createSubscription(destination, throttleRate) {
      const subscriptionId = generateSubscriptionId();

      sendRequestFrame(
        {
          subscribe: {
            destination,
            subscriptionId,
            throttleRate,
          },
        },
        socketStealth,
      );

      return subscriptionId.toString();
    }

    function generateSubscriptionId() {
      const date = new Date().getTime().toString().substring(2);
      const randomInt = Math.floor(Math.random() * 9999) + 1;
      return parseInt(randomInt + date);
    }
  });
}

function updateBar(data, sub) {
  
  var lastBar = sub.lastBar;
  let resolution = sub.resolution;
  if (resolution.includes('D')) {
    // 1 day in minutes === 1440
    resolution = 1440;
  } else if (resolution.includes('W')) {
    // 1 week in minutes === 10080
    resolution = 10080;
  }
  var coeff = resolution * 60;
  
  var rounded = (Math.floor(data.time / coeff) * coeff) / 1000;
  var lastBarSec = lastBar.time / 1000;
  var lastBarFormed;

  if (rounded > lastBarSec) {
    // create a new candle, use last close as open **PERSONAL CHOICE**

    lastBarFormed = {
      time: rounded * 1000,
      open: lastBar.close,
      high: lastBar.close,
      low: lastBar.close,
      close: data.close, //this was data.price but we don't have price attribute in
      volume: data.volume,
    };
  } else {
    // update lastBar candle!
    
    if (data.close < lastBar.low) {
      lastBar.low = data.close;
    } else if (data.close > lastBar.high) {
      lastBar.high = data.close;
    }

    lastBar.volume = data.volume;
    lastBar.close = data.close;
    lastBarFormed = lastBar;
  }
  return lastBarFormed;
}

function significantDigitsForPriceScale(significantDig)
{
  if(significantDig)
  {
    return Math.pow(10, significantDigits);
  }
  else
  {
    return instrumentType === 'CRY' ? 100000000 : instrumentType === 'FX' ? 100000 : 100;
  }
}
